import type { Context } from '@white-label-types/middleware';
import { getFeatureFlag } from '@white-label-plugin/launch-darkly';
// Config
import { FEATURE_FLAGS } from '@white-label-configuration/constants';

/**
 * Checks if the loyalty feature is enabled and redirects users accordingly.
 *
 * For details on router middleware see https://v2.nuxt.com/docs/directory-structure/middleware#router-middleware
 * For details on feature toggles see https://docs.launchdarkly.com/sdk/client-side/javascript#getting-started
 *
 * @param {Context} context
 * @returns {Promise<any>}
 */
const routerMiddlware = async ({ redirect, route }: Context): Promise<void> => {
  if (process.server) {
    return;
  }

  const isLoyaltyEnabled = Boolean(getFeatureFlag(FEATURE_FLAGS.CN_3375_PROPEL_LOYALTY_WHITELABEL));

  if (route.path !== '/loyalty' && isLoyaltyEnabled) {
    // NOTE: this eslint rule is disabled as Nuxt expects there to be different return types for router middleware
    // eslint-disable-next-line consistent-return
    return redirect('/loyalty');
  }

  if (route.path === '/loyalty' && !isLoyaltyEnabled) {
    // NOTE: this eslint rule is disabled as Nuxt expects there to be different return types for router middleware
    // eslint-disable-next-line consistent-return
    return redirect('/');
  }
};

export default routerMiddlware;
